module.exports = __webpack_public_path__ + "img/odometer.6a8bee17.png";